<template>
	<code-diff :old-string="local" :new-string="git"  :file-name="name" :context="10" output-format="side-by-side"/>
</template>
<script>

import {CodeDiff} from 'v-code-diff'

export default {
	name: 'ShowDiff',
	components: {
		CodeDiff
	},
	props: {
		local: String,
		git: String,
		name: String
	},
	data() {
		return {
		
		};
	},
	methods: {
	
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style scoped>
	.h1-buttons.no-verti::after {
		display: none;
	}
	.alert {
		text-align: start;
	}
</style>